import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Floating pop-up shell for Left Menu modules, so the screen underneath keeps its context.
// sticky: only the X closes it (no backdrop click / Escape) — for editors that must not lose work
export function RailPopup({ title, testid, onClose, children, width = "max-w-6xl", sticky = false }) {
  useEffect(() => {
    const k = (e) => { if (e.key === "Escape" && !sticky) onClose(); };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [onClose, sticky]);
  return createPortal(
    <div className="fixed inset-0 z-[60] bg-slate-900/55 backdrop-blur-sm flex items-start justify-center p-3 sm:p-6 overflow-y-auto" data-testid={testid} onClick={sticky ? undefined : onClose}>
      <div className={`relative w-full ${width} my-2 rounded-lg overflow-hidden shadow-2xl border border-slate-300 bg-slate-50`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between bg-slate-800 text-white px-4 py-2.5 sticky top-0 z-10">
          <div className="text-sm font-semibold">{title}</div>
          <button onClick={onClose} data-testid={`${testid}-close`} className="h-7 w-7 rounded-sm hover:bg-white/20 flex items-center justify-center"><X className="h-4 w-4" /></button>
        </div>
        <div className="max-h-[84vh] overflow-y-auto p-4 sm:p-6">{children}</div>
      </div>
    </div>,
    document.body
  );
}
